import { Box, Paper, PaperProps, Stack, Typography } from '@mui/material';
import PlusIcon from '@/app/assets/icons/plus.svg?react';

interface Props extends PaperProps {
  addContractorLabel: string;
  onAddContractor: () => void;
}

export const ForeignContractorsAutocompletePaper = ({
  children,
  addContractorLabel,
  onAddContractor,
  ...paperProps
}: Props) => {
  return (
    <Paper {...paperProps}>
      <Box sx={{ pt: 1 }}>
        <Stack
          direction='row'
          spacing={1}
          alignItems='center'
          sx={{
            background: '#E6F1FF',
            color: '#0B1370',
            borderRadius: '8px',
            cursor: 'pointer',
            width: 'fit-content',
            mx: 'auto',
            py: 1.5,
            px: 2.5,
            transition: 'all 0.3s ease',
          }}
          onMouseDown={(event) => event.preventDefault()}
          onClick={onAddContractor}
        >
          <Typography fontSize='inherit' color='#0B1370' fontWeight={600}>
            {addContractorLabel}
          </Typography>
          <Box
            component={PlusIcon}
            sx={{
              '& path': {
                stroke: '#0B1370',
              },
            }}
          />
        </Stack>
      </Box>
      {children}
    </Paper>
  );
};
